module.exports = __webpack_public_path__ + "static/img/l_cxjycypj.d2f6b32a.png";